export class ApiError extends Error {
  statusCode: number;
  data: any;
  constructor(statusCode: number, statusText: string, data: any) {
    super(statusText);
    this.statusCode = statusCode;
    this.data = data;
  }
}
